import { useEffect, useMemo } from 'react';

import { useSidebarStore } from '@/modules/core/components/Sidebar/store/useSidebarStore';
import globalTheme from '@/styles/theme';

import { useEditModeStore } from './useEditModeStore';

const EDIT_MODE_WIDTH = '1272px';

export const useEditModeWidth = () => {
  const { isEditMode } = useEditModeStore();
  const { setMinify, setPinned } = useSidebarStore();

  const width = useMemo(() => (isEditMode ? EDIT_MODE_WIDTH : globalTheme.defaultContentWidth), [isEditMode]);

  useEffect(() => {
    if (isEditMode) {
      setMinify(true);
      setPinned(false);
    }
  }, [isEditMode, setMinify, setPinned]);

  return { width, isEditMode };
};
